module.exports = __webpack_public_path__ + "images/eurocover_small904ebbcd080e220654a0b9541a5e704f.png";